// extracted by mini-css-extract-plugin
module.exports = {"img":"styles_img__KmSCj","layout_is_fill":"styles_layout_is_fill__AS3Id","background_image":"styles_background_image__Y4OOH"};